// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.5.0",
  date: "2026-08-12T08:15:19.796Z",
  gitInfo: {
    dirty: false,
    raw: "1ae1e2158",
    hash: "1ae1e2158",
    distance: null,
    tag: null,
    semver: null,
    suffix: "1ae1e2158",
    semverString: null
  }
};
/* tslint:enable */
